
    import '/opt/buildhome/repo/packages/x/components/code-highlighter/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["code-highlighter-demo-basic","code-highlighter-demo-custom-header","code-highlighter-demo-with-xmarkdown","code-highlighter-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/packages/x/components/code-highlighter/index.en-US.md?type=demo')
};